import React, {useState, useContext, Fragment} from 'react';
import {BrowserRouter as Router, Route, Switch, Link, Redirect} from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  NavbarText,
  Container,
  Row,
  Button
} from 'reactstrap';

import PageURL from "../PageURL.js";
import AppContext from '../AppContext.js';
import logo from '../assets/logo.png';
import PageDOP from './PageDOP.jsx';
import PageMyAccount from './PageMyAccount.jsx';
import PageCertificates from "./PageCertificates.jsx";
import PageUserAccounts from "./PageUserAccounts.jsx";
import PageCustomerAccounts from "./PageCustomerAccounts.jsx";
import PageDownloadLogs from "./PageDownloadLogs.jsx";
import {apiURL} from "../Utils/Utils.js";

const Dashboard = function() {
  const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const {appState, setAppState} = useContext(AppContext);

  const toggleMenu = function() {
    setMenuIsOpen(!menuIsOpen);
  };
  const toggleDropdown = function() {
    setDropdownIsOpen(!dropdownIsOpen);
  };

  const logOut = function() {
    document.cookie = 'auth_key=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    setAppState({});
  };

  return (
  <Fragment>
    <header className="header">
      <div className="container-fluid">
        <Row>
          <Navbar expand="md" className="w-100 py-0 header-navigation">
            <div className="navbar-brand"><Link to={PageURL.Home} className="logo-box"><img className="logo my-2" alt="logo" src={logo} /></Link></div>
            <NavbarToggler onClick={toggleMenu} />
            <Collapse isOpen={menuIsOpen} navbar className="justify-content-end">
              <Nav className="ml-auto nav-font" navbar>
                <NavItem>
                  <NavLink tag={Link} to={PageURL.Home}>Certificates</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} to={PageURL.DOP}>DOP</NavLink>
                </NavItem>
                {appState.role === 'admin' &&
                <>
                <NavItem>
                  <NavLink tag={Link} to={PageURL.downloadLogs}>Download Logs</NavLink>
                </NavItem>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    Accounts
                  </DropdownToggle>
                  <DropdownMenu right>
                    <DropdownItem>
                      <NavLink style={{color: "black"}} tag={Link} to={PageURL.customerAccounts}>Customer Accounts</NavLink>
                    </DropdownItem>
                    <DropdownItem>
                      <NavLink style={{color: "black"}} tag={Link} to={PageURL.userAccounts}>User Accounts</NavLink>
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem>
                      <NavLink style={{color: "black"}} tag={Link} to={PageURL.myAccount}>My Account</NavLink>
                    </DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown>
                </>}
                {appState.role === 'vluser' && 
                <NavItem>
                  <NavLink tag={Link} to={PageURL.myAccount}>My Account</NavLink>
                </NavItem>}
                {(appState.role === 'user' || appState.role === 'inspector') && 
                <NavItem>
                  <NavLink tag={Link} to={PageURL.myAccount}>My Account</NavLink>
                </NavItem>}
                <NavItem>
                  <a className="nav-link" href="/" onClick={(evt) => logOut()}>Log Out</a>
                </NavItem>
              </Nav>
            </Collapse>
          </Navbar>
        </Row>
      </div>
    </header>
    <Container fluid className="page-content">
      {appState.role === 'admin' &&
      <>
        <Route exact path={PageURL.customerAccounts}>
          <PageCustomerAccounts />
        </Route>
        <Route exact path={PageURL.userAccounts}>
          <PageUserAccounts />
        </Route>
        <Route exact path={PageURL.downloadLogs}>
          <PageDownloadLogs />
        </Route>
      </>}
      <Route exact path={PageURL.myAccount}>
        <PageMyAccount />
      </Route>
      <Route exact path={PageURL.DOP}>
        <PageDOP />
      </Route>
      <Route exact path={PageURL.Home}>
        <PageCertificates />
      </Route>
    </Container>
  </Fragment>
  );
};

export default Dashboard;